<template>
    <div class="attribute-picker">
        <div class="search-panel">
            <input maxlength="128" :placeholder="$t('chatbotv2.typeSearchValue')" type="text" v-model="searchText" />
            <span class="material-icons"> search </span>
        </div>
        <div class="attribute-list">
            <div
                class="d-flex flex-column justify-content-center text-center align-items-center mb-5"
                v-if="!filterAttributes().length"
            >
                <div>
                    <span class="material-icons"> search </span>
                </div>
                <div>{{ $t("chatbotv2.noResultFound") }}</div>
            </div>
            <div class="attr-select" v-if="filterAttributes('custom').length">
                <div
                    text-color="lighter"
                    text-weight="semi-bold"
                    text-type="h5"
                    class="tpl-category-select-category-name"
                >
                    {{ whatsappMode ? "Whatsapp Contact Attributes" : $t("chatbotv2.CUSTOM_ATTRIBUTES") }}
                </div>
                <div
                    data-checked="true"
                    data-index="0"
                    data-item-label="Name"
                    class="picker-item"
                    v-for="attr of filterAttributes('custom')"
                    @click="pick(attr.value)"
                    :class="{ active: defaultSelected === attr.name }"
                >
                    <span class="material-icons"> data_object </span>
                    <span class="name">
                        {{ isLocalizedAttribute(attr.name) ? $t(`chatbotv2.attr.${attr.name}`) : attr.name }}
                    </span>
                    <span class="description"> {{ attr.placeholder }} </span>
                </div>
            </div>
            <div class="attr-select">
                <div
                    text-color="lighter"
                    text-weight="semi-bold"
                    text-type="h5"
                    class="tpl-category-select-category-name"
                    v-if="filterAttributes('system').length"
                >
                    {{ $t("chatbotv2.USER_DATA") }}
                </div>
                <div
                    data-checked="true"
                    data-index="0"
                    data-item-label="Name"
                    class="picker-item"
                    v-for="attr of filterAttributes('system')"
                    @click="pick(attr.value)"
                    :class="{ active: defaultSelected === attr.value }"
                >
                    <AttributeIconPreview :attribute="attr.value" />

                    <span class="name">
                        {{ isLocalizedAttribute(attr.value) ? $t(`chatbotv2.attr.${attr.value}`) : attr.value }}
                    </span>
                    <span class="description">
                        {{
                            attr.placeholder == "Turkey" && attr.placeholder == "Male"
                                ? $t(`chatbotv2.${attr.placeholder.toLocaleLowerCase()}`)
                                : attr.placeholder
                        }}
                    </span>
                </div>
            </div>
            <div class="attr-select" v-if="filterAttributes('visitorContactProperty').length">
                <div
                    text-color="lighter"
                    text-weight="semi-bold"
                    text-type="h5"
                    class="tpl-category-select-category-name"
                >
                    VISITOR CONTACT PROPERTIES
                </div>
                <div
                    data-checked="true"
                    data-index="0"
                    data-item-label="Name"
                    class="picker-item"
                    v-for="attr of filterAttributes('visitorContactProperty')"
                    @click="pick(attr.value)"
                    :class="{ active: defaultSelected === attr.value }"
                >
                    <AttributeIconPreview attribute="object" />
                    <span class="name">
                        {{ attr.name }}
                    </span>
                    <span class="description"> {{ attr.placeholder }} </span>
                </div>
            </div>
            <div class="attr-select" v-if="filterAttributes('akinon').length">
                <div
                    text-color="lighter"
                    text-weight="semi-bold"
                    text-type="h5"
                    class="tpl-category-select-category-name"
                >
                    AKINON ATTRIBUTES
                </div>
                <div
                    data-checked="true"
                    data-index="0"
                    data-item-label="Name"
                    class="picker-item"
                    v-for="attr of filterAttributes('akinon')"
                    @click="pick(attr.value)"
                    :class="{ active: defaultSelected === attr.name }"
                >
                    <AttributeIconPreview :attribute="attr.value" />
                    <span class="name">
                        {{ isLocalizedAttribute(attr.value) ? $t(`chatbotv2.attr.${attr.value}`) : attr.value }}
                    </span>
                    <span class="description"> {{ attr.placeholder }} </span>
                </div>
            </div>
            <div class="attr-select" v-if="filterAttributes('ideasoft').length">
                <div
                    text-color="lighter"
                    text-weight="semi-bold"
                    text-type="h5"
                    class="tpl-category-select-category-name"
                >
                    IDEASOFT ATTRIBUTES
                </div>
                <div
                    data-checked="true"
                    data-index="0"
                    data-item-label="Name"
                    class="picker-item"
                    v-for="attr of filterAttributes('ideasoft')"
                    @click="pick(attr.value)"
                    :class="{ active: defaultSelected === attr.name }"
                >
                    <AttributeIconPreview :attribute="attr.value" />
                    <span class="name">
                        {{ isLocalizedAttribute(attr.value) ? $t(`chatbotv2.attr.${attr.value}`) : attr.value }}
                    </span>
                    <span class="description"> {{ attr.placeholder }} </span>
                </div>
            </div>
            <div class="attr-select" v-if="filterAttributes('probel').length">
                <div
                    text-color="lighter"
                    text-weight="semi-bold"
                    text-type="h5"
                    class="tpl-category-select-category-name"
                >
                    PROBEL ATTRIBUTES
                </div>
                <div
                    data-checked="true"
                    data-index="0"
                    data-item-label="Name"
                    class="picker-item"
                    v-for="attr of filterAttributes('probel')"
                    @click="pick(attr.value)"
                    :class="{ active: defaultSelected === attr.name }"
                >
                    <AttributeIconPreview :attribute="attr.value" />
                    <span class="name">
                        {{ isLocalizedAttribute(attr.value) ? $t(`chatbotv2.attr.${attr.value}`) : attr.value }}
                    </span>
                    <span class="description"> {{ attr.placeholder }} </span>
                </div>
            </div>
            <div class="attr-select" v-if="filterAttributes('b2cargo').length">
                <div
                    text-color="lighter"
                    text-weight="semi-bold"
                    text-type="h5"
                    class="tpl-category-select-category-name"
                >
                    B2CARGO ATTRIBUTES
                </div>
                <div
                    data-checked="true"
                    data-index="0"
                    data-item-label="Name"
                    class="picker-item"
                    v-for="attr of filterAttributes('b2cargo')"
                    @click="pick(attr.value)"
                    :class="{ active: defaultSelected === attr.name }"
                >
                    <AttributeIconPreview :attribute="attr.value" />
                    <span class="name">
                        {{ isLocalizedAttribute(attr.value) ? $t(`chatbotv2.attr.${attr.value}`) : attr.value }}
                    </span>
                    <span class="description"> {{ attr.placeholder }} </span>
                </div>
            </div>
            <hr />
            <AddCustomAttribute :on-added="pick" v-if="!whatsappMode" />
        </div>
    </div>
</template>

<script>
import AddCustomAttribute from "../common/AddCustomAttribute";
import AttributeIconPreview from "../common/AttributeIconPreview";
import systemAttributes from "../../../utils/systemAttributes";
import { mapGetters, mapState } from "vuex";
import _ from "lodash";
import log2 from "../../../../../../utils/log2";
import CONFIG from "../../../../../../config/config";
import { Attributes, Entities } from "../../../palatteEnums";

const log = log2("AttributePicker");
export default {
    name: "AttributePicker",
    components: {
        AddCustomAttribute,
        AttributeIconPreview,
        systemAttributes,
    },
    props: {
        defaultSelected: {
            type: String,
            required: false,
        },
        pick: {
            type: Function,
            required: true,
        },
        filterMode: {
            type: Boolean,
            required: false,
            default: false,
        },
        allowedAttributes: {
            type: Array,
            default: () => [],
        },
        whatsappMode: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            searchText: "",
            defaultAttributes: systemAttributes,
            Attributes,
            Entities,
        };
    },
    computed: {
        ...mapGetters({
            board: "CB/board",
        }),
        ...mapState({
            visitorContactAttributes: (state) => state.contactProperty.data || [],
        }),
    },
    methods: {
        isLocalizedAttribute(attribute) {
            const isAkinon = attribute.startsWith("akinon");
            const isIdeasoft = attribute.startsWith("ideasoft");
            const isProbel = attribute.startsWith("probel");
            const isB2Cargo = attribute.startsWith("b2cargo");
            const isEntity = Entities.includes(attribute);
            const isSystemAttributes = systemAttributes.find((attr) => attr.value === attribute);
            return isB2Cargo || isAkinon || isProbel || isEntity || isSystemAttributes || isIdeasoft;
        },
        filterAttributes(type) {
            const currentBoard = this.board(this.$route.params.id);
            log("currentBoard", currentBoard);
            const specialAttributeNames = [
                ...CONFIG.AKINON.attributes.map((x) => x.value),
                ...CONFIG.PROBEL.attributes.map((x) => x.value),
                ...CONFIG.IDEASOFT.attributes.map((x) => x.value),
                ...CONFIG.B2CARGO.attributes.map((x) => x.value),
            ];
            let allAttributes = [
                ...(this.filterMode
                    ? [
                          {
                              name: "Message",
                              placeholder: "How are you?",
                              value: "message",
                              type: "system",
                          },
                      ]
                    : []),
                ...this.defaultAttributes.filter((x) => (this.filterMode ? true : !x.filterMode || x.always)),
                ...this.visitorContactAttributes.map((x) => ({
                    name: x.label,
                    placeholder: "",
                    value: "contact_property_" + x._id,
                    type: "visitorContactProperty",
                })),
                ..._.get(currentBoard, "state.attributes", []).map((x) => ({
                    name: x,
                    placeholder: "",
                    value: x,
                    type: "custom",
                })),
            ];
            allAttributes = allAttributes.filter((x) => !specialAttributeNames.includes(x.value));
            if (this.whatsappMode) {
                allAttributes = this.allowedAttributes.map((x) => ({
                    name: x,
                    placeholder: "",
                    value: x,
                    type: "custom",
                }));
            } else {
                if (CONFIG.AKINON.enabled) {
                    allAttributes = _.concat(_.uniqBy(allAttributes, "value"), CONFIG.AKINON.attributes);
                }
                if (CONFIG.PROBEL.enabled) {
                    allAttributes = _.concat(_.uniqBy(allAttributes, "value"), CONFIG.PROBEL.attributes);
                }
                if (CONFIG.B2CARGO.enabled) {
                    allAttributes = _.concat(_.uniqBy(allAttributes, "value"), CONFIG.B2CARGO.attributes);
                }
                allAttributes = _.concat(_.uniqBy(allAttributes, "value"), CONFIG.IDEASOFT.attributes);
            }

            let result = !!this.searchText
                ? allAttributes.filter((x) => this.searchText === "" || new RegExp(this.searchText, "gi").test(x.name))
                : allAttributes;

            result = result.filter((x) => {
                return _.isEmpty(type) || x.type === type;
            });
            if (type === "custom") {
                const customAttributesPrefixList = ["akinon", "probel", "ideasoft", "b2cargo"];
                result = result.filter((x) => !customAttributesPrefixList.some((prefix) => x.name.startsWith(prefix)));
            }
            return result;
        },
    },
};
</script>

<style lang="scss">
.attribute-picker {
    background: #fff;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    max-height: 600px;
    min-height: 200px;
    user-select: none;
    width: 100%;
    padding: 5px;

    .search-panel {
        align-items: center;
        border-bottom: 1px solid #e8eef3;
        display: flex;
        flex-shrink: 0;
        position: relative;
        width: 100%;

        input {
            background: transparent;
            border: 0;
            font-size: 16px;
            height: 40px;
            line-height: 20px;
            padding-left: 45px;
            padding-right: 15px;
            width: 100%;
        }

        span {
            color: #9ba6b3;
            font-size: 18px;
            left: 15px;
            pointer-events: none;
            position: absolute;
            -webkit-transition: color 0.3s;
            transition: color 0.3s;
        }
    }

    .attribute-list {
        flex-grow: 1;
        overflow-x: hidden;
        overflow-y: auto;
        padding: 15px 15px;
        margin: 0px 5px 0px 5px;
        gap: 10px;

        .attr-select {
            margin-bottom: 10px;
        }
    }

    .picker-item {
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        cursor: pointer;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        height: 32px;
        padding: 0 5px;
        -webkit-transition: background-color 0.2s, opacity 0.2s;
        transition: background-color 0.2s, opacity 0.2s;

        &.active {
            color: #006cff !important;

            .material-icons,
            .name,
            .description {
                color: #006cff !important;
            }
        }

        &:hover {
            background-color: #f0f4f7;
        }

        .material-icons,
        .custom-attr-logo {
            color: #647283;
            font-size: 25px;
            margin-right: 11px;
        }

        .name {
            color: #22272d;
            font-size: 16px;
            font-weight: 400;
            line-height: 20px;
            margin-right: 30px;
        }

        .description {
            color: #9ba6b3;
            font-size: 15px;
            line-height: 19px;
            margin-left: auto;
            overflow: hidden !important;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
}
</style>
